import { Pipe, PipeTransform } from '@angular/core';
import ProjectContact from '../model/company/projectContact';

@Pipe({
  name: 'projectContactUniqueCompany'
})
export class ProjectContactUniqueCompanyFilter implements PipeTransform {
  transform(projectContacts: ProjectContact[]): ProjectContact[] {
    if (projectContacts == null || projectContacts.length <= 1) {
      return projectContacts;
    }
    return projectContacts.filter((projectContact, i) => {
      return (
        projectContact.company == null ||
        projectContacts.findIndex(
          pc =>
            pc.company != null && projectContact.company.id === pc.company.id
        ) === i
      );
    });
  }
}
